import * as TYPES from "./types";
import {IHeaderSettings} from "./interfaces";

export default {
    [TYPES.ADD_HEADER_SETTINGS](context: any, data: IHeaderSettings) {
        context.commit(TYPES.SET_HEADER_SETTINGS, data);

    }
}